var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switch",class:{ 'switch-on': _setup.isOn },style:(_setup.returnColors),attrs:{"tabindex":"0"},on:{"click":_setup.toggleSwitch}},[_c('span',{staticClass:"switch-circle",class:{ 'switch-on-circle': _setup.isOn }})])
}
var staticRenderFns = []

export { render, staticRenderFns }